var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9059 4.3691C17.2301 4.3691 17.5 4.63826 17.5 4.98076V5.29742C17.5 5.63159 17.2301 5.90908 16.9059 5.90908H3.09488C2.76988 5.90908 2.5 5.63159 2.5 5.29742V4.98076C2.5 4.63826 2.76988 4.3691 3.09488 4.3691H5.52464C6.01821 4.3691 6.44775 4.01827 6.55879 3.52327L6.68603 2.95495C6.88378 2.18079 7.53458 1.66663 8.27939 1.66663H11.7206C12.4573 1.66663 13.1154 2.18079 13.3059 2.91411L13.442 3.52244C13.5522 4.01827 13.9818 4.3691 14.4762 4.3691H16.9059Z",
    fill: "#2495F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6715 15.9453C15.9252 13.5811 16.3694 7.9645 16.3694 7.90784C16.3856 7.73617 16.3296 7.57367 16.2186 7.44284C16.0995 7.32034 15.9487 7.24784 15.7826 7.24784H4.22379C4.05684 7.24784 3.89799 7.32034 3.78776 7.44284C3.67592 7.57367 3.62081 7.73617 3.62891 7.90784C3.6304 7.91825 3.64634 8.11609 3.67298 8.44685C3.79134 9.91621 4.121 14.0087 4.33401 15.9453C4.48476 17.3719 5.42084 18.2686 6.77674 18.3011C7.82305 18.3252 8.90096 18.3336 10.0032 18.3336C11.0414 18.3336 12.0958 18.3252 13.1745 18.3011C14.5774 18.2769 15.5127 17.3961 15.6715 15.9453Z",
    fill: "#2495F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4335d5cc42b397a567e3533f94a6f613.svg";
export { ForwardRef as ReactComponent };